import React, { FC } from 'react';
import styled from 'styled-components';

import RemoveFillIcon from '@ad-scripts/presentation/components/common/icons/fill/remove-fill';
import webhooksResource from 'src/actions/integrations/webhooksResource';
import { Delete } from 'src/presentation/components/pages/shared/rowActions/Delete';
import { Edit } from 'src/presentation/components/pages/shared/rowActions/Edit';
import { Webhook } from 'src/actions/integrations/webhook';

type RowActionProps = {
  dataAid?: string;
  item: Webhook;
};

const RowActions: FC<RowActionProps> = ({ item }) => {
  const handleOpenDeleteModal = callbackOpenModal => {
    callbackOpenModal();
  };

  return (
    <>
      <Edit dataAid={`editLink-${item.id}`} id={item.id} />
      <Delete
        confirmationText={`Delete ${item.name}`}
        deleteAction={webhooksResource.effects.remove}
        deleteIcon={StyledTrashIcon}
        description={`Are you sure you want to delete "${item.name}"?`}
        handleOpenModal={handleOpenDeleteModal}
        id={item.id}
        submitText="Delete Webhook"
      />
    </>
  );
};

const StyledTrashIcon = styled(RemoveFillIcon)`
  fill: ${p => p.theme.colors.gray600};
`;

export default RowActions;
